export function getMcpEndpoint({
  origin,
  development,
  configuredUrl
}: {
  origin: string
  development: boolean
  configuredUrl?: string
}) {
  if (configuredUrl?.trim()) return new URL(configuredUrl.trim()).href
  const url = new URL('/api/mcp', origin)
  // 开发时 MCP 是独立进程，Vite 的 /api 代理仅指向 Main。
  if (development) url.port = '3200'
  return url.href
}

export function createMcpConfig(endpoint: string, key?: string) {
  return JSON.stringify(
    {
      mcpServers: {
        'super-mega': {
          url: endpoint,
          headers: { Authorization: `Bearer ${key || '<请填入个人 MCP 密钥>'}` }
        }
      }
    },
    null,
    2
  )
}

export function getBotMcpEndpoint(input: Parameters<typeof getMcpEndpoint>[0]) {
  const url = new URL(getMcpEndpoint(input))
  url.pathname = '/api/mcp-bot'
  url.search = ''
  url.hash = ''
  return url.href
}

export function createBotMcpConfig(input: { endpoint: string; botId: string; key?: string }) {
  return JSON.stringify(
    {
      mcpServers: {
        'super-mega': {
          url: input.endpoint,
          headers: { BotId: input.botId, GatewayKey: input.key || '<请填入机器人 MCP 密钥>' }
        }
      }
    },
    null,
    2
  )
}
